"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareFillVault = exports.prepareClaimTx = exports.prepareTransferDepositTx = exports.prepareInititalizeMining = exports.prepareRepayTx = exports.prepareBorrowTx = exports.prepareWithdrawalTx = exports.prepareWithdrawalRequestTx = exports.prepareDepositTx = exports.prepareCreatePoolTx = exports.prepareInitPoolMarketTx = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const accounts_1 = require("./accounts");
const program_1 = require("./program");
const common_1 = require("@everlend/common");
const transactions_1 = require("./transactions");
const buffer_1 = require("buffer");
const initializeMiningTx_1 = require("./transactions/initializeMiningTx");
const transactions_2 = require("./transactions");
const fillVault_1 = require("./transactions/fillVault");
const rewardProgram_1 = require("./rewardProgram");
const prepareInitPoolMarketTx = ({ connection, payerPublicKey }, poolMarket = web3_js_1.Keypair.generate()) => __awaiter(void 0, void 0, void 0, function* () {
    const lamports = yield connection.getMinimumBalanceForRentExemption(accounts_1.PoolMarket.LEN);
    const tx = new web3_js_1.Transaction();
    tx.add(web3_js_1.SystemProgram.createAccount({
        fromPubkey: payerPublicKey,
        newAccountPubkey: poolMarket.publicKey,
        lamports,
        space: accounts_1.PoolMarket.LEN,
        programId: program_1.GeneralPoolsProgram.PUBKEY,
    }));
    tx.add(new transactions_1.InitPoolMarketTx({ feePayer: payerPublicKey }, {
        poolMarket: poolMarket.publicKey,
    }));
    return { tx, keypairs: { poolMarket } };
});
exports.prepareInitPoolMarketTx = prepareInitPoolMarketTx;
const prepareCreatePoolTx = ({ connection, payerPublicKey }, poolMarket, tokenMint, tokenAccount = web3_js_1.Keypair.generate(), poolMint = web3_js_1.Keypair.generate()) => __awaiter(void 0, void 0, void 0, function* () {
    const tokenAccountlamports = yield connection.getMinimumBalanceForRentExemption(spl_token_1.AccountLayout.span);
    const poolMintlamports = yield connection.getMinimumBalanceForRentExemption(spl_token_1.MintLayout.span);
    const tx = new web3_js_1.Transaction();
    tx.add(web3_js_1.SystemProgram.createAccount({
        fromPubkey: payerPublicKey,
        newAccountPubkey: tokenAccount.publicKey,
        lamports: tokenAccountlamports,
        space: spl_token_1.AccountLayout.span,
        programId: spl_token_1.TOKEN_PROGRAM_ID,
    }));
    tx.add(web3_js_1.SystemProgram.createAccount({
        fromPubkey: payerPublicKey,
        newAccountPubkey: poolMint.publicKey,
        lamports: poolMintlamports,
        space: spl_token_1.MintLayout.span,
        programId: spl_token_1.TOKEN_PROGRAM_ID,
    }));
    const poolPubkey = yield accounts_1.Pool.getPDA(poolMarket, tokenMint);
    const poolMarketAuthority = yield program_1.GeneralPoolsProgram.findProgramAddress([poolMarket.toBuffer()]);
    tx.add(new transactions_1.CreatePoolTx({ feePayer: payerPublicKey }, {
        poolMarket,
        pool: poolPubkey,
        tokenMint,
        tokenAccount: tokenAccount.publicKey,
        poolMint: poolMint.publicKey,
        poolMarketAuthority,
    }));
    return { tx, keypairs: { tokenAccount, poolMint } };
});
exports.prepareCreatePoolTx = prepareCreatePoolTx;
const prepareDepositTx = ({ connection, payerPublicKey }, pool, amount, rewardPool, rewardAccount, source, destination) => __awaiter(void 0, void 0, void 0, function* () {
    const { data: { poolMarket, tokenAccount, poolMint, tokenMint }, } = yield accounts_1.Pool.load(connection, pool);
    const poolMarketAuthority = yield program_1.GeneralPoolsProgram.findProgramAddress([poolMarket.toBuffer()]);
    const tx = new web3_js_1.Transaction();
    const poolConfig = yield program_1.GeneralPoolsProgram.findProgramAddress([
        buffer_1.Buffer.from('config'),
        pool.toBuffer(),
    ]);
    let closeTokenAccountIx;
    let SOLDepositKeypair;
    let SOLDepositSource;
    if (tokenMint.equals(spl_token_1.NATIVE_MINT)) {
        SOLDepositKeypair = web3_js_1.Keypair.generate();
        SOLDepositSource = SOLDepositKeypair.publicKey;
        const rent = yield connection.getMinimumBalanceForRentExemption(spl_token_1.AccountLayout.span);
        const createTokenAccountIx = web3_js_1.SystemProgram.createAccount({
            fromPubkey: payerPublicKey,
            newAccountPubkey: SOLDepositSource,
            programId: spl_token_1.TOKEN_PROGRAM_ID,
            space: spl_token_1.AccountLayout.span,
            lamports: amount.addn(rent).toNumber(),
        });
        const initTokenAccountIx = spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, spl_token_1.NATIVE_MINT, SOLDepositSource, payerPublicKey);
        closeTokenAccountIx = spl_token_1.Token.createCloseAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, SOLDepositSource, payerPublicKey, payerPublicKey, []);
        tx.add(createTokenAccountIx, initTokenAccountIx);
        source = SOLDepositSource;
    }
    destination = destination !== null && destination !== void 0 ? destination : (yield (0, common_1.findAssociatedTokenAccount)(payerPublicKey, poolMint));
    !(yield connection.getAccountInfo(destination)) &&
        tx.add(new common_1.CreateAssociatedTokenAccount({ feePayer: payerPublicKey }, {
            associatedTokenAddress: destination,
            tokenMint: poolMint,
        }));
    tx.add(new transactions_1.DepositTx({ feePayer: payerPublicKey }, {
        poolConfig,
        poolMarket,
        pool,
        source,
        destination,
        tokenAccount,
        poolMint,
        rewardPool,
        rewardAccount,
        poolMarketAuthority,
        amount,
    }));
    closeTokenAccountIx && tx.add(closeTokenAccountIx);
    return { tx, keypairs: { SOLDepositKeypair } };
});
exports.prepareDepositTx = prepareDepositTx;
const prepareWithdrawalRequestTx = ({ connection, payerPublicKey }, pool, collateralAmount, rewardPool, rewardAccount, source, destination) => __awaiter(void 0, void 0, void 0, function* () {
    const { data: { tokenMint, poolMarket, tokenAccount, poolMint }, } = yield accounts_1.Pool.load(connection, pool);
    const withdrawRequests = yield accounts_1.WithdrawalRequestsState.getPDA(poolMarket, tokenMint);
    const withdrawalRequest = yield accounts_1.UserWithdrawalRequest.getPDA(withdrawRequests, payerPublicKey);
    const collateralTransit = yield program_1.GeneralPoolsProgram.findProgramAddress([
        buffer_1.Buffer.from('transit'),
        poolMarket.toBuffer(),
        poolMint.toBuffer(),
    ]);
    const tx = new web3_js_1.Transaction();
    const poolConfig = yield program_1.GeneralPoolsProgram.findProgramAddress([
        buffer_1.Buffer.from('config'),
        pool.toBuffer(),
    ]);
    destination = destination !== null && destination !== void 0 ? destination : (yield (0, common_1.findAssociatedTokenAccount)(payerPublicKey, tokenMint));
    !(yield connection.getAccountInfo(destination)) &&
        tx.add(new common_1.CreateAssociatedTokenAccount({ feePayer: payerPublicKey }, {
            associatedTokenAddress: destination,
            tokenMint,
        }));
    tx.add(new transactions_1.WithdrawalRequestTx({ feePayer: payerPublicKey }, {
        poolConfig,
        poolMarket,
        pool,
        withdrawRequests,
        withdrawalRequest,
        source,
        destination,
        tokenAccount,
        collateralTransit,
        poolMint,
        collateralAmount,
        rewardPool,
        rewardAccount,
    }));
    return { tx };
});
exports.prepareWithdrawalRequestTx = prepareWithdrawalRequestTx;
const prepareWithdrawalTx = ({ connection, payerPublicKey }, withdrawalRequest) => __awaiter(void 0, void 0, void 0, function* () {
    const { data: { from, destination, pool }, } = yield accounts_1.UserWithdrawalRequest.load(connection, withdrawalRequest);
    const { data: { tokenMint, poolMarket, poolMint, tokenAccount }, } = yield accounts_1.Pool.load(connection, pool);
    const withdrawalRequests = yield accounts_1.WithdrawalRequestsState.getPDA(poolMarket, tokenMint);
    const poolMarketAuthority = yield program_1.GeneralPoolsProgram.findProgramAddress([poolMarket.toBuffer()]);
    const collateralTransit = yield program_1.GeneralPoolsProgram.findProgramAddress([
        buffer_1.Buffer.from('transit'),
        poolMarket.toBuffer(),
        poolMint.toBuffer(),
    ]);
    let unwrapAccounts = undefined;
    if (tokenMint.equals(spl_token_1.NATIVE_MINT)) {
        const unwrapTokenAccount = yield accounts_1.UserWithdrawalRequest.getUnwrapSOLPDA(withdrawalRequest);
        unwrapAccounts = {
            tokenMint: tokenMint,
            unwrapTokenAccount: unwrapTokenAccount,
            signer: payerPublicKey,
        };
    }
    const tx = new web3_js_1.Transaction();
    !(yield connection.getAccountInfo(destination)) &&
        tx.add(new common_1.CreateAssociatedTokenAccount({ feePayer: payerPublicKey }, {
            associatedTokenAddress: destination,
            tokenMint,
        }));
    tx.add(new transactions_1.WithdrawalTx({ feePayer: payerPublicKey }, {
        poolMarket,
        pool,
        poolMarketAuthority,
        poolMint,
        withdrawalRequests,
        withdrawalRequest,
        destination,
        tokenAccount,
        collateralTransit,
        from,
        unwrapAccounts,
    }));
    return { tx };
});
exports.prepareWithdrawalTx = prepareWithdrawalTx;
const prepareBorrowTx = ({ connection, payerPublicKey }, pool, amount, destination) => __awaiter(void 0, void 0, void 0, function* () {
    const { data: { poolMarket, tokenAccount, tokenMint }, } = yield accounts_1.Pool.load(connection, pool);
    const poolMarketAuthority = yield program_1.GeneralPoolsProgram.findProgramAddress([poolMarket.toBuffer()]);
    const poolBorrowAuthority = yield accounts_1.PoolBorrowAuthority.getPDA(pool, payerPublicKey);
    const tx = new web3_js_1.Transaction();
    destination = destination !== null && destination !== void 0 ? destination : (yield (0, common_1.findAssociatedTokenAccount)(payerPublicKey, tokenMint));
    !(yield connection.getAccountInfo(destination)) &&
        tx.add(new common_1.CreateAssociatedTokenAccount({ feePayer: payerPublicKey }, {
            associatedTokenAddress: destination,
            tokenMint: tokenMint,
        }));
    tx.add(new transactions_1.BorrowTx({ feePayer: payerPublicKey }, {
        poolMarket,
        pool,
        poolBorrowAuthority,
        destination,
        tokenAccount,
        poolMarketAuthority,
        amount,
    }));
    return { tx };
});
exports.prepareBorrowTx = prepareBorrowTx;
const prepareRepayTx = ({ connection, payerPublicKey }, pool, amount, interestAmount, source) => __awaiter(void 0, void 0, void 0, function* () {
    const { data: { poolMarket, tokenAccount }, } = yield accounts_1.Pool.load(connection, pool);
    const poolBorrowAuthority = yield accounts_1.PoolBorrowAuthority.getPDA(pool, payerPublicKey);
    const tx = new transactions_1.RepayTx({ feePayer: payerPublicKey }, {
        poolMarket,
        pool,
        poolBorrowAuthority,
        source,
        tokenAccount,
        amount,
        interestAmount,
    });
    return { tx };
});
exports.prepareRepayTx = prepareRepayTx;
const prepareInititalizeMining = ({ payerPublicKey }, rewardPool) => __awaiter(void 0, void 0, void 0, function* () {
    const tx = new web3_js_1.Transaction();
    const mining = yield accounts_1.Mining.getPDA(payerPublicKey, rewardPool);
    tx.add(new initializeMiningTx_1.InitializeMining({ feePayer: payerPublicKey }, {
        rewardPool,
        mining,
        user: payerPublicKey,
    }));
    return { tx };
});
exports.prepareInititalizeMining = prepareInititalizeMining;
const prepareTransferDepositTx = ({ payerPublicKey }, pool, source, destination, destinationUserAuthority, rewardPool, rewardAccount, destinationRewardAccount) => __awaiter(void 0, void 0, void 0, function* () {
    const tx = new web3_js_1.Transaction();
    tx.add(new transactions_1.TransferDepositTx({ feePayer: payerPublicKey }, {
        pool,
        source,
        destination,
        destinationUserAuthority,
        rewardPool,
        rewardAccount,
        destinationRewardAccount,
    }));
    return { tx };
});
exports.prepareTransferDepositTx = prepareTransferDepositTx;
const prepareClaimTx = ({ payerPublicKey }, rewardPool, rewardMint, userRewardTokenAccount) => __awaiter(void 0, void 0, void 0, function* () {
    const tx = new web3_js_1.Transaction();
    const mining = yield accounts_1.Mining.getPDA(payerPublicKey, rewardPool);
    const [vault] = yield web3_js_1.PublicKey.findProgramAddress([buffer_1.Buffer.from('vault'), rewardPool.toBuffer(), rewardMint.toBuffer()], rewardProgram_1.RewardProgram.PUBKEY);
    tx.add(new transactions_2.ClaimTx({ feePayer: payerPublicKey }, {
        rewardPool,
        rewardMint,
        vault,
        mining,
        userRewardTokenAccount,
    }));
    return { tx };
});
exports.prepareClaimTx = prepareClaimTx;
const prepareFillVault = ({ payerPublicKey }, rewardPool, rewardMint, vault, feeAccount, authority, from, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const tx = new web3_js_1.Transaction();
    tx.add(new fillVault_1.FillVaultTx({ feePayer: payerPublicKey }, {
        rewardPool,
        rewardMint,
        vault,
        feeAccount,
        authority,
        from,
        amount,
    }));
    return { tx };
});
exports.prepareFillVault = prepareFillVault;
//# sourceMappingURL=actions.js.map